const kubatura = {
    t: 'Kubatura',
    name: 'kubatura',
    type: 'number',
    unit: 'm³'
}

export default kubatura